<template>
    <v-dialog
            v-model="dialog"
            width="400"
            v-bind="$attrs"
            v-on="$listeners"
    >
        <template v-slot:activator="{ on }">
            <v-icon
                    icon
                    v-on="on"
            >
                {{buttontext}} {{icon}}
            </v-icon>
        </template>
        <v-card>
            <v-card-title>
                {{title}}
            </v-card-title>
            <v-card-text>
                <slot/>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="dialog=false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    components: {},
    props:['title', 'icon','buttontext'],
    name: "BaseDialog",
    data () {
      return {
        dialog: false,
      }
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>